export default class Locale_LookupOptionsEditor {
	EditValues: string = "Edit values";
	MatchDirection: string = "Match direction";
	FullNameDelimiter: string = "Fullname delimiter";
	DefaultExpandedDepth: string = "Default expanded depth";
	ImportValuesFromText: string = "Import values from text (line-break seperated strings)";
	ImportString: string = "Import string";
}